import { lang } from '@umu/ukit-lang';
export enum PAY_METHOD {
    /**
     * 1:企业年租
     */
    BY_YEAR = 1,
    /**
     * 2:企业买断
     */
    BY_NOTHING = 2,
    /**
     * 3: 按账户购买
     */
    BY_USER = 3,
    /**
     * 4: 按课包购买
     */
    BY_PACKAGE = 4,
}

export const PAY_METHOD_TITLE: {
    [props: number]: string;
} = {
    [PAY_METHOD.BY_YEAR]: lang('企业年租'),
    [PAY_METHOD.BY_NOTHING]: lang('企业买断'),
    [PAY_METHOD.BY_USER]: lang('按账户购买'),
    [PAY_METHOD.BY_PACKAGE]: lang('按课包购买'),
};

export interface IPurchaseMethod {
    method: PAY_METHOD;
    price: string;
    amount: string;
    account_num?: number; // 购买账户数，按账户购买才需要用上:
}

export interface IPurchaseInfo {
    course_id: string;
    purchase_method: PAY_METHOD;
    account_num?: number; // 购买账户数，按账户购买才需要用上
}
